import "./pdf-hover-styles.css";

import React, { Component } from "react";
import classNames from 'classnames/bind'
import { Icon } from "antd"
import { Tooltip } from 'antd'
import { injectIntl } from 'react-intl'

function DartIcon(props) {
    return (
        <React.Fragment>
            <div className={props.isActive ? " pdf-hover dart-style active" : " pdf-hover dart-style"} style={{ cursor: "pointer" }} onClick={props.onClick}>
                <svg viewBox="64 64 896 896"
                    focusable="false" data-icon="message" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                    <path d="M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z">
                    </path>
                </svg>
            </div>
        </React.Fragment>
    )
}

function ExpandIcon(props) {
    return (
        <React.Fragment>
            <div className={props.isActive ? "up-expand-icon active " : "up-expand-icon"} onClick={props.onClick}>
                {/* <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.15052 0.75C0.652082 0.75 0.248047 1.15404 0.248047 1.65247V5.66768C0.248047 6.16612 0.652082 6.57015 1.15052 6.57015C1.64895 6.57015 2.05299 6.16612 2.05299 5.66768V3.73061L6.13328 7.8109C6.30983 7.98745 6.54101 8.07485 6.77181 8.07485C7.00261 8.07485 7.23379 7.98745 7.41034 7.8109C7.76293 7.45831 7.76291 6.88743 7.41032 6.53484L3.42951 2.55494H5.16573C5.66416 2.55494 6.0682 2.15091 6.0682 1.65247C6.0682 1.15404 5.66416 0.75 5.16573 0.75H1.15052Z" fill="#0096D6" /><path d="M14.803 0.75C14.3045 0.75 13.9005 1.15404 13.9005 1.65247C13.9005 2.15091 14.3045 2.55494 14.803 2.55494H16.5393L12.5594 6.53486C12.2068 6.88745 12.2068 7.45831 12.5594 7.8109C12.7359 7.98745 12.9671 8.07485 13.1979 8.07485C13.4287 8.07485 13.6599 7.98745 13.8364 7.8109L17.9167 3.73061V5.66768C17.9167 6.16612 18.3208 6.57015 18.8192 6.57015C19.3176 6.57015 19.7217 6.16612 19.7217 5.66768L19.7217 1.65178C19.7203 1.15402 19.3168 0.75 18.8182 0.75H14.803Z" fill="#0096D6" /><path d="M13.8354 12.3582C13.4828 12.0056 12.912 12.0056 12.5594 12.3582C12.2068 12.7108 12.2068 13.2816 12.5594 13.6342L16.5393 17.6142H14.803C14.3045 17.6142 13.9005 18.0182 13.9005 18.5166C13.9005 19.0151 14.3045 19.4191 14.803 19.4191H18.8182C19.3166 19.4191 19.7207 19.0151 19.7207 18.5166V14.5014C19.7207 14.003 19.3166 13.599 18.8182 13.599C18.3197 13.599 17.9157 14.003 17.9157 14.5014V16.4385L13.8354 12.3582Z" fill="#0096D6" /><path d="M7.40942 12.3584C7.0576 12.0055 6.48593 12.0061 6.13363 12.357L2.05299 16.4376V14.5015C2.05299 14.0031 1.64895 13.5991 1.15052 13.5991C0.652082 13.5991 0.248047 14.0031 0.248047 14.5015V18.5168C0.248047 19.0152 0.652082 19.4192 1.15052 19.4192H5.16573C5.66416 19.4192 6.0682 19.0152 6.0682 18.5168C6.0682 18.0183 5.66416 17.6143 5.16573 17.6143H3.42942L7.40933 13.6344C7.7619 13.2818 7.76193 12.711 7.40942 12.3584Z" fill="#0096D6" /></svg> */}
                <Icon type="eye" style={{ color: "#FFFF", fontSize: "40px", cursor: "pointer" }} />
            </div>
        </React.Fragment>
    )
}
class PdfHover extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHover: false
        };
    }
    setIsHover = () => this.setState({ isHover: true });
    unsetIsHover = () => this.setState({ isHover: false });

    render() {
        const { isHover } = this.state;
        const { children, handleSelectExpandAsset, handleShowMessage, intl } = this.props;

        const converElementClasses = classNames("hover-element", {
            "hover-active": isHover
        });
        return (
            <React.Fragment>
                <div
                    className="box-pdf"
                    onMouseEnter={this.setIsHover}
                    onMouseLeave={this.unsetIsHover}
                >
                    <div className="child-style">
                        {children && children}
                    </div>
                    <div className={converElementClasses}>
                        <Tooltip placement="top" title={intl.formatMessage({ id: "comments_title" })}>
                            <span></span>
                            <DartIcon onClick={handleShowMessage} />
                        </Tooltip>
                        <Tooltip placement="top" title={intl.formatMessage({ id: "expand_asset" })}>
                            <span></span>
                            <ExpandIcon onClick={handleSelectExpandAsset} />
                        </Tooltip>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default injectIntl(PdfHover)